import { Component, Input, OnInit } from '@angular/core';
import {Signature} from '../../domain/signature';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.css'],
    standalone: false
})
export class SignatureComponent implements OnInit {
  @Input() signature: Signature;

  constructor(public domSanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  getSignatureUri() {
    return 'data:image/PNG;base64,' + this.signature.Base64PngData;
  }
}
